module.exports = __webpack_public_path__ + "img/google-G.82977f9c.svg";